import type { SelfServiceAPI } from 'types';
import type { Options } from '../types';
import api from 'lib/axios/api';
import handleServiceError from '../utils/handleServiceError';

const getBooking = async (bookingId: string, options: Options = {}): Promise<SelfServiceAPI.GetBooking.Response> => {
  try {
    const { data } = await api.get(`/bookings/${bookingId}`);
    return data;
  } catch (error) {
    handleServiceError(error, {
      operationName: `GET /bookings/${bookingId}`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default getBooking;
